import { useContext } from 'react';
import { formatCurrency } from '@s20/common/util/number';
import CommonContext from '../../Common';

export const PriceDisplay = ({ amount }) => {
    const context = useContext(CommonContext);
    const currencyCode = context?.tenant?.defaultCurrencyCode || 'USD';
    const formattedPrice = formatCurrency(amount, currencyCode);
    return (
        <span>
            {formattedPrice}
        </span>
    );
};

export const FormatPrice = ({ amount }) => {
    const formattedPrice = formatCurrency(amount, undefined, false);
    return (
        <span>
            {formattedPrice}
        </span>
    );
};
